import {
  Component,
  Input,
  OnInit,
  AfterViewInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { Actionnaire } from "../../../interfaces/Actionnaire";
import {
  Action,
  ActionGroup,
  ColumnConfig,
} from "../../../components/_custom-table/interface";
import { ToolsService } from "../../../services/tools.service";
import { ToastrService } from "../../../components/_toastr/toastr.service";
import { HttpService } from "../../../services/http.service";
import { MouvementShort } from "../../../interfaces/Mouvement";
import { AlertDialogService } from "../../../components/_alert-dialog/alert-dialog.service";
import { MouvementDialogService } from "../../mouvement-dialog/mouvement-dialog.service";

@Component({
  selector: "app-actions",
  templateUrl: "./actions.component.html",
  standalone: false,
})
export class ActionsComponent implements OnInit, AfterViewInit {
  @ViewChild("sensCell") sensCellTpl!: TemplateRef<any>;
  @ViewChild("statutCell") statutCellTpl!: TemplateRef<any>;
  @Input() actionnaire: Actionnaire;

  isLoading: boolean = false;
  mouvements: MouvementShort[] = [];

  customTemplates: { [key: string]: TemplateRef<any> } = {};

  columns: ColumnConfig[] = [
    {
      key: "mouvement_Date",
      label: "Date",
      filter: {
        type: "date",
        format: "dd/MM/yyyy",
      },
    },
    {
      key: "mouvement_Nature",
      label: "Nature",
      filter: { type: "text" },
    },
    {
      key: "mouvement_Sens",
      label: "Sens",
      filter: {
        type: "select",
        options: [
          { value: -1, label: "Sortie" },
          { value: 1, label: "Entrée" },
        ],
      },
    },
    {
      key: "mouvement_Valeur",
      label: "Valeur",
      filter: { type: "money" },
    },
    {
      key: "mouvement_Statut",
      label: "Statut",
      filter: {
        type: "select",
        options: [
          { value: 0, label: "Effectué" },
          { value: 1, label: "A faire" },
          { value: 2, label: "Futur" },
        ],
      },
    },
  ];

  tableActions: Action[] = [
    {
      label: "Créer nouveau",
      icon: "add",
      class: "btn-primary",
      callback: () => {
        this.openMouvement(0);
      },
    },
  ];

  rowActions: ActionGroup[] = [
    {
      actions: [
        {
          label: "Modifier",
          icon: "edit",
          class: "txt-info",
          callback: (m: MouvementShort) => {
            this.openMouvement(m.mouvement_ID);
          },
        },
        {
          label: "Supprimer",
          icon: "delete",
          class: "txt-danger",
          callback: (m: MouvementShort) => {
            this._mouvementDialog.openDeleteDialog(
              m.mouvement_ID,
              this.actionnaire.actionnaire_ID,
              () => {
                this.getMouvements();
              }
            );
          },
        },
      ],
    },
  ];

  constructor(
    private _http: HttpService,
    private _toast: ToastrService,
    private _tools: ToolsService,
    private _alert: AlertDialogService,
    private _mouvementDialog: MouvementDialogService
  ) {}

  ngOnInit(): void {
    this.getMouvements();
  }

  ngAfterViewInit(): void {
    this.customTemplates = {
      mouvement_Sens: this.sensCellTpl,
      mouvement_Statut: this.statutCellTpl,
    };
  }

  getMouvements(): void {
    this.isLoading = true;
    this._http.GET(
      "/api/mouvement",
      {
        actionnaire_ID: this.actionnaire.actionnaire_ID,
      },
      (result) => {
        if (result.isOk) {
          this.mouvements = result.obj;
          this.isLoading = false;
        } else {
          this._toast.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
        this.isLoading = false;
      },
      (error) => {
        this._tools.showHttpError(error);
        this.isLoading = false;
      }
    );
  }

  openMouvement(mouvementId: number): void {
    this._mouvementDialog.openDialog(
      mouvementId,
      this.actionnaire.actionnaire_ID,
      () => {
        this.getMouvements();
      }
    );
  }

  deleteMouvement(mouvementId: number): void {
    this._http.DELETE(
      "/api/mouvement/" + mouvementId,
      null,
      (result: any) => {
        if (result.isOk) {
          this._toast.show({
            title: "Succès",
            message: "Mouvement supprimé avec succès",
            type: "success",
          });
          this.getMouvements();
        } else {
          this._toast.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
      },
      (error: any) => {
        this._tools.showHttpError(error);
      }
    );
  }
}
